export function NewPageBadge() {
  return (
    <div className="flex h-8 w-fit flex-col justify-center rounded-2xl border border-product-blue/10 bg-product-blue/10 px-2.5 font-semibold text-product-blue">
      NEW
    </div>
  )
}
